import Vue from 'vue'
import App from './App.vue'
import store from './store'
import domtoimage from 'dom-to-image';
import Vuelidate from 'vuelidate';
import api from './api';

// import 'bootstrap/dist/css/bootstrap.min.css';

import 'document-register-element/build/document-register-element';
import vueCustomElement from 'vue-custom-element';

Vue.use(vueCustomElement);

Vue.use(Vuelidate);

Object.defineProperty(Vue.prototype, '$domtoimage', { value: domtoimage });
Object.defineProperty(Vue.prototype, '$api', { value: api });

Vue.config.productionTip = false;

App.store = store;
Vue.customElement('tile-customizer', App);

// new Vue({
//   store,
//   render: h => h(App)
// }).$mount('#app')
